import type { IconData } from '@stacksjs/iconify-core'

export const gw4x3: IconData = {
  "body": "<path fill=\"#ce1126\" d=\"M0 0h220v480H0z\"/><path fill=\"#fcd116\" d=\"M220 0h420v240H220z\"/><path fill=\"#009e49\" d=\"M220 240h420v240H220z\"/><g id=\"SVGIpnxv3Bj\" transform=\"matrix(80 0 0 80 110 240)\"><path id=\"SVGxb37zcxS\" fill=\"#000001\" d=\"M0-1v1h.5\" transform=\"rotate(18 0 -1)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGxb37zcxS\" transform=\"scale(-1 1)\"/></g><use width=\"100%\" height=\"100%\" href=\"#SVGIpnxv3Bj\" transform=\"rotate(72 110 240)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGIpnxv3Bj\" transform=\"rotate(144 110 240)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGIpnxv3Bj\" transform=\"rotate(-144 110 240)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGIpnxv3Bj\" transform=\"rotate(-72 110 240)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gw4x3
